import { TUint64 } from "@pro/common/contracts/atomicassets";
import { app, eos, world } from "../../App";
import { EosActionBase } from "../EosActionBase";

export class StakeAction extends EosActionBase
{
	constructor(private readonly assetId: TUint64, private readonly templateId: number)
	{
		super("transfer");
	}

	async onExecute()
	{
		await eos.transfer(this.assetId, "stake");
	}

	async onSelfUpdate(): Promise<void>
	{
		switch (app.assetConf.findByTemplateId(this.templateId)?.schema_name) {
			case "books":
				app.store.books.removeItem(this.assetId);
				break;
			case "symbols":
				app.store.symbols.removeItem(this.assetId);
				break;
			case "heroes":
				app.store.heroes.removeItem(this.assetId);
				break;
		}
		await world.updateStakedAsset(this.assetId);
	}
}